// Liste des territoires (Outre-mer + France + pays voisins) + indicatifs telephoniques
// iso : code ISO 3166 pour le drapeau image (flagcdn.com/w40/{iso}.png)

export const TERRITOIRES = [
  { value: 'Guadeloupe', label: 'Guadeloupe', iso: 'gp', dial: '+590' },
  { value: 'Martinique', label: 'Martinique', iso: 'mq', dial: '+596' },
  { value: 'Guyane', label: 'Guyane', iso: 'gf', dial: '+594' },
  { value: 'Réunion', label: 'La Réunion', iso: 're', dial: '+262' },
  { value: 'Mayotte', label: 'Mayotte', iso: 'yt', dial: '+262' },
  { value: 'Saint-Martin', label: 'Saint-Martin', iso: 'mf', dial: '+590' },
  { value: 'Saint-Barthélemy', label: 'Saint-Barthélemy', iso: 'bl', dial: '+590' },
  { value: 'Saint-Pierre-et-Miquelon', label: 'Saint-Pierre-et-Miquelon', iso: 'pm', dial: '+508' },
  { value: 'Nouvelle-Calédonie', label: 'Nouvelle-Calédonie', iso: 'nc', dial: '+687' },
  { value: 'Polynésie française', label: 'Polynésie française', iso: 'pf', dial: '+689' },
  { value: 'Wallis-et-Futuna', label: 'Wallis-et-Futuna', iso: 'wf', dial: '+681' },
  { value: 'France métropolitaine', label: 'France métropolitaine', iso: 'fr', dial: '+33' },
  // Caraïbes voisins
  { value: 'Dominique', label: 'Dominique', iso: 'dm', dial: '+1767' },
  { value: 'Sainte-Lucie', label: 'Sainte-Lucie', iso: 'lc', dial: '+1758' },
  { value: 'Haïti', label: 'Haïti', iso: 'ht', dial: '+509' },
  { value: 'République dominicaine', label: 'République dominicaine', iso: 'do', dial: '+1809' },
  { value: 'Cuba', label: 'Cuba', iso: 'cu', dial: '+53' },
  { value: 'Trinité-et-Tobago', label: 'Trinité-et-Tobago', iso: 'tt', dial: '+1868' },
  { value: 'Barbade', label: 'Barbade', iso: 'bb', dial: '+1246' },
  // Guyane voisins
  { value: 'Suriname', label: 'Suriname', iso: 'sr', dial: '+597' },
  { value: 'Brésil', label: 'Brésil', iso: 'br', dial: '+55' },
  // Océan Indien voisins
  { value: 'Madagascar', label: 'Madagascar', iso: 'mg', dial: '+261' },
  { value: 'Maurice', label: 'Maurice', iso: 'mu', dial: '+230' },
  { value: 'Comores', label: 'Comores', iso: 'km', dial: '+269' },
  { value: 'Seychelles', label: 'Seychelles', iso: 'sc', dial: '+248' },
  // Pacifique voisins
  { value: 'Vanuatu', label: 'Vanuatu', iso: 'vu', dial: '+678' },
  { value: 'Fidji', label: 'Fidji', iso: 'fj', dial: '+679' },
  // Europe partenaires
  { value: 'Belgique', label: 'Belgique', iso: 'be', dial: '+32' },
  { value: 'Suisse', label: 'Suisse', iso: 'ch', dial: '+41' },
  { value: 'Luxembourg', label: 'Luxembourg', iso: 'lu', dial: '+352' },
  { value: 'Canada', label: 'Canada', iso: 'ca', dial: '+1' },
  // Autre
  { value: 'Autre', label: 'Autre', iso: '', dial: '' },
];

// Indicatifs pour l'input telephone (peut differer du territoire)
export const PHONE_COUNTRIES = TERRITOIRES.filter(t => t.dial).map(t => ({
  code: t.value,
  name: t.label,
  iso: t.iso,
  dial: t.dial,
}));

export const findTerritoire = (value) => TERRITOIRES.find(t => t.value === value);

/** Rend une petite image drapeau (fallback: cadre vide). Utiliser avec width={20} height={14}. */
export const flagUrl = (iso, w = 40) =>
  iso ? `https://flagcdn.com/w${w}/${iso}.png` : '';
